import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";

interface NotesModalFieldType {
  name: string;
  type: InputfieldTypes;
  label: string;
  placeholder: string;
  required?: boolean;
  maxLenght?: number;
  showCount?: boolean;
}

export const addNotesModalFields: NotesModalFieldType[] = [
  {
    name: "typeofNotes",
    type: InputfieldTypes.TEXT,
    label: "Notes Type",
    placeholder: "Enter notes type",
    required: true,
  },
  {
    name: "notes",
    type: InputfieldTypes.TEXT_AREA,
    label: "Notes",
    placeholder: "Enter notes",
    required: true,
    maxLenght: 500,
    showCount: true,
  },
];
